module.exports = function () {
  return new Worker(__webpack_public_path__ + "ab7ccf3382d160ad6e52.worker.js");
};